import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import PageShell from '../components/PageShell';
import CustomerNav from '../components/CustomerNav';
import request from '../api';
import { sanitizeIntegerInput } from '../numberUtils';

function RoomJoin() {
    const [token] = useState(localStorage.getItem('customerToken'));
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [joining, setJoining] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        setJoining(true);
        try {
            const room = await request('/customer/rooms/join', {
                method: 'POST',
                token,
                body: { code },
            });
            navigate(`/room/${room.id}`);
        } catch (err) {
            setError(err.message);
        } finally {
            setJoining(false);
        }
    };

    if (!token) {
        return (
            <PageShell title="Inicio de Sesión Requerido" nav={<Button component={RouterLink} to="/auctions" color="inherit">Volver a Subastas</Button>} maxWidth="sm">
                <Alert severity="info">
                    <RouterLink to="/auctions" style={{ color: 'inherit', fontWeight: 700 }}>Inicia sesión o regístrate</RouterLink> para unirte a una subasta en vivo.
                </Alert>
            </PageShell>
        );
    }

    return (
        <PageShell title="Unirse a Subasta en Vivo" nav={<CustomerNav />} maxWidth="sm">
            <Paper sx={{ p: { xs: 3, sm: 4 } }}>
                <Typography color="text.secondary" sx={{ mb: 3 }}>
                    Ingresa el código de 4 dígitos que te compartió la tienda para unirte a la sala.
                </Typography>
                <Box component="form" onSubmit={submit}>
                    <TextField
                        label="Código"
                        value={code}
                        onChange={(e) => setCode(sanitizeIntegerInput(e.target.value).slice(0, 4))}
                        fullWidth
                        autoFocus
                        inputProps={{
                            inputMode: 'numeric',
                            pattern: '[0-9]*',
                            maxLength: 4,
                            style: { letterSpacing: '0.5em', textAlign: 'center', fontSize: '1.5rem' },
                        }}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        fullWidth
                        disabled={code.length !== 4 || joining}
                        sx={{ mt: 3 }}
                    >
                        {joining ? 'Uniéndose…' : 'Unirse'}
                    </Button>
                    {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                </Box>
            </Paper>
        </PageShell>
    );
}

export default RoomJoin;
